import { render, staticRenderFns } from "./AddressBookEntries.vue?vue&type=template&id=c32516c6&"
import script from "./AddressBookEntries.vue?vue&type=script&lang=js&"
export * from "./AddressBookEntries.vue?vue&type=script&lang=js&"
import style0 from "./AddressBookEntries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports